import { request } from "@umijs/max";

export async function queryCurrentUser(options?: { [key: string]: any }) {
    return request('https://identity.dhhp.edu.vn/user', {
        method: 'GET',
        ...(options || {}),
    });
}

/** đăng nhập POST /api/login/account */
export async function login(body: any) {
    return request('https://identity.dhhp.edu.vn/login/password-sign-in', {
        method: 'POST',
        data: body
    });
}

export const apiGetDepartment = (id: number) => request(`department/${id}`);

export const apiGetDepartmentOptions = () => request(`department/options`);

export const apiTopUserFile = () => request(`user/top-file-list`);

export async function apiUserDetail(id?: string) {
    return request(`https://identity.dhhp.edu.vn/user/details/${id}`);
}

export async function apiUserMonthlyActivity(id?: string) {
    return request(`user/monthly-activity-chart`, {
        params: {
            id
        }
    });
}